import type { JSX } from 'react';
import { Link } from 'react-router';
import { AuthLayout } from '../app/AuthLayout';
import { useT } from '../i18n/useT';

export const NotEnabledScreen = (): JSX.Element => {
  const t = useT();
  return (
    <AuthLayout>
      <h1 className="ow-heading">{t('Not available')}</h1>
      <p>{t('Invite Owner is not turned on for your rental company.')}</p>
      <Link className="ow-link" to="/logout">
        {t('Sign out')}
      </Link>
    </AuthLayout>
  );
};
